import styled from "@emotion/styled";
import { BaseInput, baseInputClasses } from "@kaltura/ds-react-components";
import { Search24Icon } from "@kaltura/ds-react-icons";
import { KeyboardEvent, useState } from "react";

export interface KeywordSearchInputProps {
    placeholder: string;
    /**
     * search input aria-label
     * mandatory because search input has no visual label
     */
    ariaLabel: string;
    /**
     * submit search callback
     */
    onSubmit: (value: string) => void;
}

const StyledSearchInput = styled(BaseInput)(({ theme }) => ({
    width: 205,
    borderColor: theme.kaltura.palette.tone4,
    [`&.${baseInputClasses.adornedStart}`]: {
        svg: {
            marginRight: 0,
            color: theme.kaltura.palette.tone3,
        },
    },
    "& input::-webkit-search-cancel-button": {
        display: "none",
    },
}));

export const KeywordSearchInput = ({ placeholder, ariaLabel, onSubmit }: KeywordSearchInputProps) => {
    const [innerValue, setInnerValue] = useState("");
    /**
     * submit search on enter key
     */
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== "Enter") {
            return;
        }

        onSubmit((event.target as HTMLInputElement).value);
    };

    return (
        <StyledSearchInput
            placeholder={placeholder}
            aria-label={ariaLabel}
            startAdornment={<Search24Icon />}
            value={innerValue}
            onKeyDown={handleKeyDown}
            onChange={(e) => setInnerValue(e.target.value)}
        />
    );
};
